import * as firebase from 'firebase/app';
import * as React from 'react';
import { Debouncer } from './debouncer';
import { EditorPane } from './components/editorPane';
import { Entry } from './components/entry';
import { EntryDictionary } from './components/entryList';
import { EntryListPane } from './components/entryListPane';
import 'firebase/firestore';
import './styles/main.css';

interface MainProps {

}

interface MainState {
  entries: EntryDictionary;
  selectedEntryId: string | null;
  isSelectedEntryPersisted: boolean;
}

export class Main extends React.Component<MainProps, MainState> {
  fbApp: firebase.app.App;
  db: firebase.firestore.Firestore;
  persistSelectedEntryDebouncer: Debouncer;
  
  initFirebase(): void {
    const config = {
      apiKey: 'AIzaSyADuVegU52vOrYn2DIdzbbFl_jeUutpTA4',
      authDomain: 'scratch-pad-d86f1.firebaseapp.com',
      // databaseURL: 'https://scratch-pad-d86f1.firebaseio.com',
      projectId: 'scratch-pad-d86f1',
      // storageBucket: 'scratch-pad-d86f1.appspot.com',
      // messagingSenderId: '447014967388'
    };
    this.fbApp = firebase.initializeApp(config);
    this.db = firebase.firestore();
  }
  
  readEntries(): void {
    let entries: { [id: string]: Entry } = {};
    this.db.collection('entries')
    .get()
    .then(function(this: Main, querySnapshot: firebase.firestore.QuerySnapshot) {
      querySnapshot.forEach(function(entry: firebase.firestore.DocumentSnapshot) {
        entries[entry.id] = entry.data() as Entry;
      });
      // Force a re-render now that we have values to show.
      this.setState({
        ...this.state,
        entries: entries,
        selectedEntryId: Object.keys(entries)[0],
      });
    }.bind(this))
    .catch(function(error: firebase.firestore.FirestoreError) {
      // tslint:disable-next-line:no-console
      console.error('Oops!');
    });
  }

  saveNewEntry(newEntry: Entry): void {
    this.db.collection('entries')
    .add(newEntry)
    .then(function(this: Main, docRef: firebase.firestore.DocumentReference) {
      this.setState({
        entries: {
          ...this.state.entries,
          [docRef.id]: newEntry,
        },
        selectedEntryId: docRef.id,
      });
    }.bind(this))
    .catch(function(error: firebase.firestore.FirestoreError) {
      // tslint:disable-next-line:no-console
      console.error('Augh!');
    });
  }

  constructor(props: MainProps) {
    super(props);
    this.initFirebase();
    this.state = {
      entries: {},
      selectedEntryId: null,
      isSelectedEntryPersisted: true,
    };

    this.persistSelectedEntryDebouncer = new Debouncer(
      () => {
        this.persistSelectedEntry();
      },
      1000);

    this.editSelectedEntry = this.editSelectedEntry.bind(this);
    this.editSelectedContent = this.editSelectedContent.bind(this);
    this.editSelectedShort = this.editSelectedShort.bind(this);
    this.selectEntry = this.selectEntry.bind(this);
  }

  componentDidMount() {
    this.readEntries();
  }

  editSelectedContent(value: string) {
    this.editSelectedEntry({
      content: value,
    });
  }

  editSelectedShort(value: string) {
    this.editSelectedEntry({
      short: value,
    });
  }

  editSelectedEntry(newValue: Partial<Entry>) {
    const selectedEntry = this.state.entries[this.state.selectedEntryId!];
    const newEntry: Entry = {
      short: 'short' in newValue ? newValue.short! : selectedEntry.short,
      content: 'content' in newValue ? newValue.content! : selectedEntry.content,
    };

    this.setState({
      entries: {
        ...this.state.entries,
        [this.state.selectedEntryId!]: newEntry,
      },
      isSelectedEntryPersisted: false,
    });

    this.persistSelectedEntryDebouncer.go();
  }

  persistSelectedEntry() {
    const id = this.state.selectedEntryId!;
    this.db.collection('entries').doc(id).update({
      ...this.state.entries[id],
    }).then(function(this: Main) {
      // TODO: there's a bug here. If the selected entry is modified between the time the update is issued and the
      // .then part of the promise is evaluated, setting the state to true could incorrectly indicate that _those_
      // changes have been saved, when they haven't.
      this.setState({...this.state, isSelectedEntryPersisted: true});
    }.bind(this)).catch(function(error: firebase.firestore.FirestoreError) {
      // tslint:disable-next-line:no-console
      console.error('Oops!');
    });
  }

  selectEntry(entryId: string) {
    if (!this.state.isSelectedEntryPersisted) {
      this.persistSelectedEntryDebouncer.cancel();
      this.persistSelectedEntry();
    }

    this.setState({
      ...this.state,
      selectedEntryId: entryId,
      isSelectedEntryPersisted: true, // TODO: Premature (saving to the db could fail), but slightly clearer UI
    });
  }

  render() {
    if (this.state.selectedEntryId) {
      const selectedEntry: Entry = this.state.entries[this.state.selectedEntryId]!;
      return (
        <div className="layout">
          <EntryListPane
            entries={this.state.entries}
            selectedEntryId={this.state.selectedEntryId}
            onEntrySelected={this.selectEntry}
            onAddEntry={() => this.saveNewEntry({short: 'New Entry', content: ''})}
          />
          <EditorPane
            changeContentHandler={this.editSelectedContent}
            changeShortHandler={this.editSelectedShort}
            entry={selectedEntry}
            isDirty={!this.state.isSelectedEntryPersisted}
          />
        </div>
      );
    } else {
      return <div />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/main.tsx